module.exports = __webpack_public_path__ + "img/otherReport.55f95c0c.svg";